const urlHost = document?.location?.host || '';

const addScript = (src) => {
    const script = document.createElement('script');

    script.src = src;

    document.head.appendChild(script);
};

const addGtm = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event      : 'gtm.js'
    });

    addScript('https://www.googletagmanager.com/gtm.js?id=GTM-PFDXKZM5');
};

const addMetrica = () => {
    const src = 'https://mc.yandex.ru/metrika/tag.js';

    window.ym = window.ym || function ym() {
        (window.ym.a = window.ym.a || []).push(arguments);
    };
    window.ym.l = 1 * new Date();

    const alreadyLoaded = Array.from(document.scripts).some((script) => script.src === src);

    if (!alreadyLoaded) {
        addScript(src);
    }

    window.ym(102510141, 'init', {
        clickmap           : true,
        trackLinks         : true,
        accurateTrackBounce: true,
        webvisor           : true
    });
};

const addCustomScripts = () => {
    // Подключаем только на проде
    if (urlHost === 'broker.tekta.ru') {
        addScript('https://app.comagic.ru/static/cs.min.js?k=kXcT9pUVQvnPHpapmTGtxUeeiIiGDdr4');
        addGtm();
        addMetrica();
    }
};

export default addCustomScripts;
